import "./tournament-round-tile.scss";
import {
  defaultGapping,
  defaultLayouts,
  GSButton,
  GSInfoGroup,
  GSItemList,
} from "golfstatus_react_components";
import { getDateTimeOn } from "../../../helpers/Dates";
import { getStateColor } from "../../../helpers/Converters";
import { useRoundActionHooks, getRoundName } from "../../../hooks/round/roundHooks";

const TournamentRoundTile = (props) => {
  const { round } = props;

  const { priorityActions } = useRoundActionHooks(round);

  const roundName = {
    sectionItems: [
      {
        type: "primary no-wrap",
        value: `Round ${getRoundName(round)}`,
      },
    ],
  };

  const roundInfo = {
    sectionItems: [
      {
        type: "secondary no-wrap",
        value: `${round?.tournamentFormats?.map?.((f) => f.name)?.join?.(",")}`,
      },
      {
        type: "secondary no-wrap",
        value: `${getDateTimeOn(round?.startAt)}` ?? `TBD`,
      },
      {
        type: "secondary no-wrap",
        value: round?.facility?.name ?? `Invalid Facility`,
      },
      {
        type: "secondary no-wrap",
        value: round?.courses?.[0]?.name
          ? `${round?.courses
              ?.map?.((t) => t.name)
              ?.join?.(" Course, ")} Course`
          : ``,
      },
    ],
  };

  const roundState = {
    sectionItems: [
      {
        type: " no-wrap",
        value: (
          <GSButton
            type={`secondary pill ${getStateColor(round)}`}
            title={round?.state}
          ></GSButton>
        ),
      },
    ],
  };

  const roundActions = {
    sectionItems: [
      {
        type: " no-wrap full-width",
        value: (
          <GSItemList
            listStyle={{
              ...defaultLayouts.fullWidth,
              ...defaultGapping.mediumGap,
            }}
            type="vertical"
            items={priorityActions}
            listItem={(action) => (
              <GSButton style={{ ...defaultLayouts.fullWidth }} {...action} />
            )}
          />
        ),
      },
    ],
  };

  let group = [
    {
      fit: "stretch",
      sections: [roundName, roundInfo, roundState, roundActions],
    },
  ];
  return (
    <tournament-round-tile>
      <GSInfoGroup dataGroups={group} />
    </tournament-round-tile>
  );
};

export default TournamentRoundTile;
